export default {
  SEO: {
    description:
      'Для защиты клиентов от контрафактной продукции разработана особая маркировка — наклейка с символом проверки подлинности Tested.Genuine., содержащая уникальный код. Она размещается на упаковке некоторых категорий оригинальных запасных частей и технических жидкостей Volkswagen, Audi, ŠKODA и Volkswagen Коммерческие автомобили с сентября 2018 года.',
    lang: 'ru',
    meta: ['meta'],
    keywords: ['Volkswagen'],
    title: 'Проверка подлинности',
  },
  Header: {
    Profile: {
      title: 'Личный кабинет',
    },
    DropDown: {
      signIn: 'Войти в личный кабинет',
      registration: 'Зарегистрироваться',
      profile: 'Личный кабинет',
      idp: 'Мой профиль',
      statistics: 'Статистика',
      logOut: 'Выйти',
      main: 'Главная страница',
    },
    Description: {
      h1: 'Проверка подлинности',
      description:
        'Оригинальные запасные части, моторное масло и технические жидкости Volkswagen, Audi, ŠKODA, Volkswagen Коммерческие автомобили отличаются высоким качеством, идеально соответствуют характеристикам автомобиля, обеспечивают его безопасность и эффективную работу. Проверьте, является ли приобретенный вами продукт подлинным, прежде чем принять решение о его использовании.',
    },
  },
  Sticker: {
    title: 'Наклейка Tested. Genuine.',
    description:
      'Наклейкой Tested.Genuine. маркируются товары, которые часто становятся объектом подделки.',
    sticker1: 'Защитный слой',
    sticker2: 'Под защитным слоем',
  },
  Marking: {
    title: 'Какие товары маркируются?',
    description1: 'Тормозные<br>колодки и диски',
    description2: 'Масляные, топливные,<br>воздушные, салонные фильтры',
    description3: 'Моторные и<br>трансмиссионные масла',
    description4: 'Масла для гидросистем<br>и прочие тех. жидкости',
    description5: 'Свечи зажигания<br>и накаливания',
    description6: 'Тормозная<br>жидкость',
  },
  Instructions: {
    title: 'На что обратить внимание?',
    description:
      'При покупке товара обращайте внимание на состояние и целостность наклейки – она не должна быть надорвана, защитный слой не должен быть снят.',
    sticker1: 'Целостная',
    sticker2: 'Надорвана частично',
    sticker3: 'Отклеена полностью',
  },
  Form: {
    FeedBack: {
      largeFileError: 'Размер фотографий превышает допустимые нормы',
      serverError: 'Произошла ошибка на стороне сервера',
      authError: 'Время сессии истекло, просьба авторизоваться еще раз',
      fill: 'Заполните форму обратной связи',
      personalH: 'Персональные данные',
      name: 'Как мы можем к вам обращаться?*',
      email: 'e-mail*',
      emailError: 'Введите корректный адресс электронной почты',
      requiredField: 'Поле обязательно к заполнению',
      phone: 'Телефон*',
      dataH: 'Данные о покупке',
      shop: 'Магазин',
      webShop: 'Интернет-магазин',
      service: 'Станция технического обслуживания',
      store: 'Название*',
      address: 'Адрес*',
      photoCheck: 'Загрузить скан/фото чека*',
      photoItem: 'Загрузить фото товара*',
      otherPhoto: 'Загрузить дополнительные фото',
      notification1:
        'Доступные форматы для загрузки: <span>jpeg, png.</span><br /> Максимальный объем файлов: <span>100 Мб</span>',
      notification2:
        'Общее фото упаковки со всех сторон, фото вблизи размещенных этикеток, четкие фото товара со всех сторон.',
      extraInfoH: 'Дополнительная информация*',
      extraInfo: 'Оставьте комментарий или задайте вопрос',

      required: 'Обязательное поле*',
      submit: 'Отправить форму',
      tokenExpired:
        'Действие просрочено по таймауту. Пожалуйста, войдите снова',
      consent: 'Я согласен с',
      consentTerms: 'Условиями использования и&nbsp;обработки запроса',
      termsTitle: 'Условия использования и&nbsp;обработки запроса',
      disclaimer: `
        <p>Настоящим <strong>даю согласие на&nbsp;обработку предоставленных мной при&nbsp;заполнении анкеты на&nbsp;сайте персональных данных</strong> (включая имя, фамилия, номер телефона, адрес электронной почты), а&nbsp;также данных о&nbsp;моем местонахождении в момент отправки запроса (широта и долгота)  ООО&nbsp;«ФОЛЬКСВАГЕН&nbsp;Груп&nbsp;Рус» (248926, г.&nbsp;Калуга, ул.&nbsp;Автомобильная д.&nbsp;1 / адрес Филиала в&nbsp;г.&nbsp;Москве (почтовый адрес): 117485, г.&nbsp;Москва, ул.&nbsp;Обручева, д.&nbsp;30/1)</p>
        <p><strong>с&nbsp;целями:</strong> обработки моего запроса и&nbsp;коммуникации со&nbsp;мной в&nbsp;целях, связанных с&nbsp;обработкой и&nbsp;выполнением моего запроса <strong>с&nbsp;помощью различных средств связи</strong>, а&nbsp;именно посредством:</p>
        <p>интернет; сообщений на&nbsp;адрес электронной почты; коротких текстовых сообщений (SMS) и&nbsp;мультимедийных сообщений (MMS) на&nbsp;номер телефона; а&nbsp;также посредством использования информационно-коммуникационных сервисов, таких как&nbsp;Viber, WhatsApp и&nbsp;тому подобных; телефонных звонков.</p>
        <p>Я&nbsp;разрешаю <strong>совершать со&nbsp;своими персональными данными следующие действия:</strong> сбор, систематизацию, накопление, хранение (в&nbsp;электронном виде и&nbsp;на&nbsp;бумажном носителе), уточнение (обновление, изменение), использование, распространение (в&nbsp;том числе передачу) моих персональных данных третьим лицам <strong>(ООО&nbsp;«Авента-Инфо», 121099, г.&nbsp;Москва, 2-й&nbsp;Смоленский пер.&nbsp;д.&nbsp;¼ , ком.&nbsp;4 и ООО&nbsp;“Агентство интеллектуальной собственности” (ООО&nbsp;“АИС”), 115404, г.&nbsp;Москва, ул.&nbsp;6-я&nbsp;Радиальная, д.5&nbsp;корп.&nbsp;4, кв.&nbsp;250)</strong>, с&nbsp;которыми у&nbsp;ООО&nbsp;«ФОЛЬКСВАГЕН&nbsp;Груп&nbsp;Рус» имеются действующие договоры, в&nbsp;рамках которых ООО&nbsp;«ФОЛЬКСВАГЕН&nbsp;Груп&nbsp;Рус» поручает обработку персональных данных в&nbsp;вышеуказанных целях, включая трансграничную передачу персональных данных, блокирование, удаление, уничтожение, с&nbsp;использованием средств автоматизации и&nbsp;без использования таких средств.</p>
        <p>Я&nbsp;подтверждаю, что&nbsp;давая настоящее согласие на обработку моих вышеуказанных персональных данных, я&nbsp;нахожусь на&nbsp;территории Российской Федерации.</p>
        <p>Настоящее согласие на&nbsp;обработку моих персональных данных действует до&nbsp;момента выполнения моего запроса и&nbsp;может быть отозвано мною ранее в&nbsp;соответствии со&nbsp;статьей&nbsp;9 Федерального закона от&nbsp;27.07.2006&nbsp;года №152-ФЗ «О&nbsp;персональных данных» посредством направления соответствующего письменного заявления по&nbsp;почтовому адресу (адрес Филиала в г.&nbsp;Москве) ООО&nbsp;«ФОЛЬКСВАГЕН&nbsp;Груп&nbsp;Рус», указанного в&nbsp;настоящем согласии.</p>
        <p>ООО&nbsp;«ФОЛЬКСВАГЕН&nbsp;Груп&nbsp;Рус» ведет деятельность на&nbsp;территории Российской Федерации в&nbsp;соответствии с&nbsp;законодательством Российской Федерации. Предлагаемые ООО&nbsp;«ФОЛЬКСВАГЕН&nbsp;Груп&nbsp;Рус», а&nbsp;также привлекаемыми им&nbsp;третьими лицами в&nbsp;заявленных в&nbsp;настоящем согласии целях услуги доступны к&nbsp;получению на&nbsp;территории Российской Федерации. Мониторинг потребительского поведения лиц, находящихся за&nbsp;пределами Российской Федерации, не&nbsp;ведется.</p>`,
      disclaimerOld:
        'Настоящим даю согласие на&nbsp;обработку моих вышеуказанных персональных данных ООО &laquo;ФОЛЬКСВАГЕН Груп Рус&raquo; (248926, г. Калуга, ул. Автомобильная д.&nbsp;1&nbsp;/ адрес Филиала в&nbsp;г. Москве (почтовый адрес): 117485, г. Москва, ул. Обручева, д. 30/1) с&nbsp;целями: обработки моего запроса, направленного через сайт www.testedgenuine.ru, и&nbsp;коммуникации со&nbsp;мной в&nbsp;целях, связанных с&nbsp;обработкой и&nbsp;выполнением моего запроса с&nbsp;помощью различных средств связи, а&nbsp;именно посредством: интернет; сообщений на&nbsp;адрес электронной почты; коротких текстовых сообщений (SMS) и&nbsp;мультимедийных сообщений (MMS) на&nbsp;номер телефона; а&nbsp;также посредством использования информационно-коммуникационных сервисов, таких как Viber, WhatsApp и&nbsp;тому подобных; телефонных звонков. Я&nbsp;разрешаю совершать со&nbsp;своими персональными данными следующие действия: сбор, систематизацию, накопление, хранение (в&nbsp;электронном виде и&nbsp;на&nbsp;бумажном носителе), уточнение (обновление, изменение), использование, распространение (в&nbsp;том числе передачу) моих персональных данных третьим лицам (ООО &laquo;Авента-Инфо&raquo; ИНН 7702360374 и&nbsp;ООО &laquo;Агентство интеллектуальной собственности&raquo; (ООО &laquo;АИС&raquo;) ИНН 7724897437) с&nbsp;которыми у&nbsp;ООО &laquo;ФОЛЬКСВАГЕН Груп Рус&raquo; имеются действующие договоры, в&nbsp;рамках которых ООО &laquo;ФОЛЬКСВАГЕН Груп Рус&raquo; поручает обработку персональных данных в&nbsp;вышеуказанных целях, включая трансграничную передачу персональных данных, обезличивание, блокирование, уничтожение, с&nbsp;использованием средств автоматизации и&nbsp;без использования таких средств. Я&nbsp;подтверждаю, что давая настоящее согласие на&nbsp;обработку моих вышеуказанных персональных данных, я&nbsp;нахожусь на&nbsp;территории Российской Федерации. Настоящее согласие на&nbsp;обработку моих персональных данных действует до&nbsp;момента выполнения моего запроса, направленного через сайт www.testedgenuine.ru и&nbsp;может быть отозвано мною ранее в&nbsp;соответствии со&nbsp;статьей 9&nbsp;Федерального закона от&nbsp;27.07.2006 года &#8470;&nbsp;152-ФЗ &laquo;О&nbsp;персональных данных&raquo; посредством направления соответствующего письменного заявления по&nbsp;почтовому адресу (адрес Филиала в&nbsp;г. Москве) ООО &laquo;ФОЛЬКСВАГЕН Груп Рус&raquo;, указанного в&nbsp;настоящем согласии. ООО &laquo;ФОЛЬКСВАГЕН Груп Рус&raquo; ведет деятельность на&nbsp;территории Российской Федерации в&nbsp;соответствии с&nbsp;законодательством Российской Федерации. Предлагаемые ООО &laquo;ФОЛЬКСВАГЕН Груп Рус&raquo;, а&nbsp;также привлекаемым им&nbsp;третьими лицами в&nbsp;заявленных в&nbsp;настоящем согласии целях услуги доступны к&nbsp;получению на&nbsp;территории Российской Федерации. Мониторинг потребительского поведения лиц, находящихся за&nbsp;пределами Российской Федерации, не&nbsp;ведется.',
    },
    question: {
      findCode: 'Как найти код проверки',
      findCodeForHeader: 'Проверить код',
      whyAutorization: 'Зачем нужна авторизация?',
    },
    sendCodeBlock: {
      checkCode: 'Проверка',
      autorization: 'Авторизоваться и проверить',
      support: 'Оставить обращение',
    },
    support: 'Оставить обращение',
    enterCode: 'Введите код',
    enterCodeHeader: 'Ввести код',
    isLoading: 'Ваш запрос обрабатывается, подождите, пожалуйста.',
    isContrafact: 'Что делать, если Вы купили подделку?',
    isErrorCode: 'Такого номера нет',
    title:
      'Введите уникальный <br/> 15-значный код для проверки <br/>подлинности продукта',
    description:
      'Если купленный вами товар не&nbsp;является оригинальным, то&nbsp;вы&nbsp;имеете право вернуть его и&nbsp;потребовать возврата уплаченной за&nbsp;товар суммы согласно&nbsp;ст.&nbsp;18&nbsp;закона &laquo;О&nbsp;защите прав потребителей&raquo;.',
    tooltipInfo: {
      findCode:
        'Уникальный 15-значный код является надежным способом для проверки оригинальности и подтверждения качества купленного вами товара. Вы&nbsp;найдете код на&nbsp;товарной упаковке на&nbsp;нижнем слое защитного стикера.',
      whyAutorization:
        'При авторизации для Вас становится доступным личный кабинет, где Вы можете просматривать историю проверок своих товаров, а также направлять нам обращения.',
    },
    status: {
      n: 'Код подлинный',
      k: 'Код не зарегистрирован',
      d: 'Код с повторной проверкой',
    },
  },
  Media: {
    title: 'Как отличить оригинал<br>от подделки?',
    items: [
      {
        title: 'Оригинал или контрафакт',
        description:
          'Что скрывается за контрафактной продукцией и как обнаружить подделку.',
        downloadText: 'Скачать материалы',
        download: [
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_Parts_Brochure_AUDI_RUS.pdf`,
            cover: 'originalAudi_ru',
          },
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_Parts_Brochure_SKODA_RUS.pdf`,
            cover: 'originalSkoda_ru',
          },
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_Parts_Brochure_VW_RUS.pdf`,
            cover: 'originalVw_ru',
          },
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_parts_brochure_NFZ.pdf`,
            cover: 'originalVwCom',
          },
        ],
      },
      {
        title: 'Тормозные колодки и диски ',
        description:
          'Движение — это всегда риск. Движение на дороге — риск вдвойне. Технический тренер учебного центра Audi рассказывает, в чем отличие оригинальных тормозных колодок и дисков от контрафактных копий (поддельных запасных частей).',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/tormoza.mp4`,
          name: 'tormoza',
          cover: 'brakes',
        },
      },
      {
        title: 'Легкосплавные диски',
        description:
          'Выдержит ли контрафактный диск удар при наезде колеса на препятствие? Узнайте из видеосюжета.',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/diski.mp4`,
          name: 'diski',
          cover: 'discs',
        },
      },
      {
        title: 'Масляные фильтры',
        description:
          'Применение масляных фильтров низкого качества может привести к повреждению двигателя. Оригинальные масляные фильтры обеспечивают долговечность двигателя, защищая его от повышенного трения, вызываемого частицами грязи и продуктами износа.',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/maslo.mp4`,
          name: 'maslo',
          cover: 'oil',
        },
      },
      {
        title: 'Моторное масло',
        description:
          'Использование поддельного моторного масла опасно и снижает срок службы автомобиля. Чтобы защититься от подделок  – покупайте только оригинальное моторное масло со стикером проверки Tested.Genuine',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/engine_oil.mp4`,
          name: 'engine_oil',
          cover: 'engine_oil',
        },
      },
    ],
  },
  Dealers: {
    title: 'Адреса официальных дилеров',
    map: 'Перейти к карте',
    items: [
      {
        name: 'Volkswagen',
        href:
          'https://www.volkswagen.ru/app/dealers/vw-ru/ru/%D0%94%D0%B8%D0%BB%D0%B5%D1%80%D1%8B%20Volkswagen/+/53.72267442183233/47.7992045/4/+/+/+/+',
      },
      {
        name: 'Volkswagen<br>Коммерческие автомобили',
        href:
          'https://www.volkswagen-commercial.ru/app/dealers/vwn-ru/ru/%D0%94%D0%B8%D0%BB%D0%B5%D1%80%D1%8B%20Volkswagen%20%D0%9A%D0%BE%D0%BC%D0%BC%D0%B5%D1%80%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B5%20%D0%B0%D0%B2%D1%82%D0%BE%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D0%B8/+/52.619/47.79920449999997/4/+/+/+/+',
        classForCommercialName: 'commercial',
      },
      {
        name: 'Audi',
        href: 'https://www.audi.ru/ru/web/ru/dealer-search.html',
      },
      {
        name: 'ŠKODA',
        href: 'http://www.skoda-avto.ru/dealer',
      },
    ],
  },
  Contacts: {
    hotline: 'Горячая линия <br /> &laquo;Проверка уникального кода&raquo;',
    phone: '+78007007328',
    formatPhone: '+7 800 700-73-28',
    qr: 'QR Код',
    vw: {
      qr: 'vw',
      title: 'Мобильное приложение <br /> &laquo;Volkswagen&raquo;',
      googleplay:
        'https://play.google.com/store/apps/details?id=ru.vwgroup.service&hl=ru',
      appstore: 'https://itunes.apple.com/us/app/vw-servis/id575858147?mt=8',
    },
    audi: {
      qr: 'audi',
      title: 'Мобильное приложение <br /> &laquo;Audi&raquo;',
      googleplay:
        'https://play.google.com/store/apps/details?id=ru.audi.service&hl=ru',
      appstore: 'https://itunes.apple.com/us/app/audi-service/id664580565?mt=8',
    },
    skoda: {
      qr: 'skoda',
      title: 'Мобильное приложение <br /> &laquo;ŠKODA&raquo;',
      googleplay:
        'https://play.google.com/store/apps/details?id=ru.skoda.service',
      appstore: 'https://apps.apple.com/ru/app/skoda-app/id1491066713',
    },
  },
  Footer: {
    description:
      'Если вы столкнулись с подделкой, отправьте сообщение с темой письма «Подделка» на электронный адрес <a href="mailto:tg@vgrus.ru">tg@vgrus.ru</a>',
    copy: '&copy;&nbsp;Volkswagen Group Rus, 2023. Все права защищены.',
  },
  Profile: {
    title: 'Проверки',
    buttonCheck: 'Проверить товар',
    warningMessage:
      'Уважаемые Дамы и&nbsp;Господа, личный кабинет пользователя работает в&nbsp;тестовом режиме. При&nbsp;обнаружении ошибок просьба сообщить на&nbsp;<a href="mailto:tg@vgrus.ru">tg@vgrus.ru</a>. Приносим свои извинения за&nbsp;неудобства.',
    filters: {
      numberOfChecks: 'Все проверки',
      myChecks: 'Мои обращения',
      reverifiedsCode: 'Код с повторной проверкой',
      codeNotRegistered: 'Код не зарегистрирован',
      genuineCode: 'Код подлинный',
    },
    infoCheck: {
      mainInfo: {
        code: 'Код:',
        result: 'Результат:',
        date: 'Дата:',
        device: 'Проверялся:',
        web: 'сайт',
        mobile: 'мобильное приложение',
        place: 'Место проверки:',
        checks: 'Обращения:',
        status: {
          n: 'Подлинность подтверждена',
          k: 'Возможна подделка! <br>Код не зарегистрирован',
          d: 'Возможна подделка! Код проверяется ',
          region: 'Регион предыдущей проверки: ',
        },
      },
      details: {
        numberOfChecks: 'Количество моих проверок:',
        supportButton: 'Оставить обращение',
        supportNumberText: 'Номер поддержки: ',
        supportNumberValue: '+7 800 700-73-28',
        downloadResult: 'Скачать результат проверки',
        sendResult: 'Отправить результат на почту',
        sendMail: 'Результат проверки отправлен на почту',
        myChecks: 'Мои обращения',
        myCheck: '(Моя проверка)',
        check: {
          checkNumber: '№ Обращения:',
          trade: 'Место:',
          place: 'Название:',
          time: 'Время:',
          comment: 'Комментарий:',
        },
      },
    },
  },
  Statistics: {
    title: 'Статистика',
  },
};
